import { createContext, useContext } from 'react';
import { FeatureFlagsContextData as ContextData } from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider: ReactContextProvider } = context;

export const useFeatureFlagsContext = () => useContext(context);
